import React from 'react';
import styled from "styled-components";
import Tabs, {Tab} from "@molecules/tabs/tabs";
import {isEmpty} from "@helpers/helpers";

const HayaatTabsSection = () => {

    const tabsDetails = [
        {
            faTitle: 'رستوران',
            enTitle: 'Restaurant',
            contentTitle: 'رستوران',
            contentPartOne: 'مرکز تجاری، اقامتی حیات و ایمان دارای سه رستوران در طبقات مختلف با چشم‌اندازی کم‌نظیر از حرم مطهر امام رضا(ع) با سرو انواع غذاهای ایرانی، فرنگی، عربی، فست‌فود و انواع دسرها و نوشیدنی‌ها است.',
            imageSrc: '/_img/landings/hayaat/tabs/restaurant.jpg',
        },
        {
            faTitle: 'پارکینگ',
            enTitle: 'Parking',
            contentTitle: 'پارکینگ',
            contentPartOne: 'از ویژگی‌های ممتاز مرکز خرید و اقامت حیات و ایمان، بهره‌مندی این مرکز از پارکینگ وسیع دو طبقه جهت خریداران و مراجعه‌کنندگان بخش تجاری و اقامتی به تفکیک است. اتصال سراسری پارکینگ‌های مرکز تجاری اقامتی حیات شرق در ترازهای طبقات ۲- و ۳- و دو رمپ اختصاصی از دیگر ویژگی‌های پارکینگ مرکز خرید و اقامت حیات شرق می‌باشد.',
            imageSrc: '/_img/landings/hayaat/tabs/parking.jpg',
        },
        {
            faTitle: 'لابی',
            enTitle: 'Lobby',
            contentTitle: 'لابی',
            contentPartOne: 'هتل‌آپارتمان حیات و ایمان، با بیش از ۴۵۰ واحد اقامتی با تنوعی کم‌نظیر و با بهره‌گیری از خدمات هتلی در ۵ لابی مستقل با خدمات ۲۴ ساعته، سعی کرده اقامتی آسوده را برای زائرین حضرت امام رضا(ع) فراهم آورد. ارائه اینترنت پرسرعت به کلیه مهمانان در اتاق‌ها، مینی‌بار، اتاق‌های هوشمند مجهز به سیستم IPTV ،VOIP ،BMS و آنتن مرکزی از امکانات ویژه مرکز خرید و اقامت حیات و ایمان می‌باشد.',
            imageSrc: '/_img/landings/hayaat/tabs/loby.jpg',
        },
        {
            faTitle: 'لاندری',
            enTitle: 'Laundry',
            contentTitle: 'لاندری',
            contentPartOne: 'مجهزترین لاندری شرق کشور، از دیگر امکانات مرکز تجاری و اقامتی حیات و ایمان است. این لاندری با خدمات به مهمانان هتل حیات و ایمان آسایشی دو چندان را فراهم آورده است.',
            imageSrc: '/_img/landings/hayaat/tabs/laundry.jpg',
        },
        {
            faTitle: 'ماساژ',
            enTitle: 'Massage',
            contentTitle: 'ماساژ',
            contentPartOne: 'مرکز ماساژ حیات و ایمان با بهره‌گیری از متدهای روز مساژ و ماساژورهای مجرب و باتجربه، لحظات خوش و آسوده‌تری را برای شما رقم خواهد زد.',
            imageSrc: '/_img/landings/hayaat/tabs/massage.jpg',
        },
        {
            faTitle: 'سالن نگهداری کودکان',
            enTitle: 'Child Care Hall',
            contentTitle: 'سالن نگهداری کودکان',
            contentPartOne: 'سالن نگهداری کودکان هتل حیات و ایمان بابهره‌گیری از مربیان مجرب و با ارائه محیطی امن و شاد برای کودکان.',
            imageSrc: '/_img/landings/hayaat/tabs/childcarehall.jpg',
        },
        {
            faTitle: 'اتاق‌ها',
            enTitle: 'Rooms',
            contentTitle: 'اتاق‌ها',
            contentPartOne: 'ترکیب اتاق‌های هتل حیات و ایمان به‌صورت واحدهای آپارتمانی یک‌ خواب، دو خواب و سه خواب و سوئیت می باشد. حداقل فضای طراحی‌شده در هتل حیات و ایمان ۵۰ متر مربع بوده که در میان سایر هتل‌های مشهد ممتاز می‌باشد.',
            imageSrc: '/_img/landings/hayaat/tabs/rooms.jpg',
        },
        {
            faTitle: 'خدمات',
            enTitle: 'Services',
            contentTitle: 'خدمات',
            contentPartOne: 'خدمات ۲۴ ساعته خانه‌داری، کافی‌شاپ، رستوران‌، تاکسی‌سرویس، اینترنت پرسرعت و خدمات ماساژ بخش کوچکی از خدمات هتل بزرگ حیات و ایمان می باشد.',
            imageSrc: '/_img/landings/hayaat/tabs/services.jpg',
        },
        {
            faTitle: 'کارواش',
            enTitle: 'Carwash',
            contentTitle: 'کارواش',
            contentPartOne: 'ارائه خدمات کارواش در پارکینگ مرکز خرید و اقامت حیات و ایمان، از دیگر خدمات این مرکز تجاری اقامتی بزرگ است.',
            imageSrc: '/_img/landings/hayaat/tabs/carwash.jpg',
        },
    ];

    return (
        <Container className="container sm-fluid">
            <Tabs activeTab="1" itemsClassName="overflow-x-auto">
                {
                    tabsDetails.map(tab =>
                        <Tab title={<TabTitle faTitle={tab.faTitle} enTitle={tab.enTitle}/>}>
                            <TabContent
                                contentTitle={tab.contentTitle}
                                partOne={tab.contentPartOne}
                                partTwo={tab.contentPartTwo}
                                imageSrc={tab.imageSrc}
                            />
                        </Tab>
                    )
                }
            </Tabs>
        </Container>
    );
};

export default React.memo(HayaatTabsSection);

const TabTitle = React.memo(({faTitle, enTitle}) => {
    return (
        <React.Fragment>
            <div className="persian-title">{faTitle}</div>
            <div className="english-title">{enTitle}</div>
        </React.Fragment>
    )
});

const TabContent = React.memo(({contentTitle, partOne, partTwo, imageSrc}) => {

    return (
        <ContentContainer className="row flex-column-reverse flex-lg-row mx-0">
            <div className="col-lg-6 d-flex px-24 px-lg-0">
                <div className="d-flex flex-column justify-content-center px-0 px-lg-40 pb-24 pb-lg-0">
                    <h2 className="h1-bold font-weight-500 d-none d-lg-block">{contentTitle}</h2>

                    <p className="h3-normal mt-24">{partOne}</p>

                    {
                        !isEmpty(partTwo) ?
                            <p className="h3-normal mt-24">{partTwo}</p>
                            : ''
                    }
                </div>
            </div>


            <div className="col-lg-6 px-0 px-lg-0 tab-image-wrapper bg-gray100">
                <ContentImageCard>
                    <img className="img-cover" src={imageSrc} alt={""}/>
                </ContentImageCard>
            </div>
        </ContentContainer>
    )
});

// styles

const Container = styled.div`
    .english-title {
      font-size: 15px;
      font-weight: 300;
    }

    .persian-title {
        min-width: 100px;
    }

    .overflow-x-auto {
        overflow-x: auto;
    }

    ul {
          white-space: nowrap;
          border-bottom: none;

          .active-tab {
              width: 0 !important;
              left: 0 !important;
          }

          li {
              font-size: 24px;
              font-weight: 500;
              color: ${props => props.theme.gray400};
              border-left: 1px solid ${props => props.theme.gray200};
              padding: 16px 24px;
              text-align: center;
              border-bottom: none !important;
          }
    }

    .active {
          font-size: 24px;
          font-weight: bold;
          color: ${props => props.theme.black};
          background-color: ${props => props.theme.gray200};
    }

    @media (max-width: ${props => props.theme.screenSmMax}) {
          li {
              font-size: 18px;
    
              &.acitve {
                  font-size: 21px;
                  font-weight: bold;
              }
          }
    }
`;

const ContentContainer = styled.div`
    background-color: ${props => props.theme.primary};
    color: #ffffff;
    border-radius: 0 0 8px 8px;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        background-color: #ffffff;
        color: ${props => props.theme.black};
        border-radius: 0;
    }
`;

const ContentImageCard = styled.div`
    width: 100%;
    height: 466px;
   
    img {
        border-radius: 0 0 0 8px;
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        height: 292px;
        
        img {
            border-radius: 0;
        }
    }
`;